<template>
    <AgreementFormGeneral :handleSubmit="handleSubmition" :values="item"
                          :errors="violations" :initialValues="retrieved"></AgreementFormGeneral>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AgreementFormGeneral from './FormGeneral.vue'

  export default {
    components: {
      AgreementFormGeneral,
    },
    computed: {
      ...mapGetters({
        retrieved: 'agreement/update/retrieved',
        updated: 'agreement/update/updated',
        violations: 'agreement/update/violations',
      })
    },
    data: function () {
      return {
        tabIndex: 0,
        item: {},
        errors: {}
      }
    },
    created(){
      this.$store.dispatch('agreement/customer/load')
    },
    methods: {
      handleSubmition (values) {
        this.$store.dispatch('agreement/update/update', {item: this.retrieved, values: values})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateGeneral.vue?44b7c9e1